/*
 * サブシステム名：燃費管理
 * 機能名：給油実績一覧登録
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'
import dolly from '@/rahmen/utils/dolly'
import filter from '@/rahmen/utils/filters'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
// import indexeddb from '@/ddv2.library/indexeddb'
import modals from '@/ddv2.library/modals'
import message from '@/ddv2.library/messages'
// import spsvalidator from '@/ddv2.library/validator4sps'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdFileInput from '@/components/DdFileInput'
import DdSpreadSheet from '@/components/DdSpreadSheetCe'
import DdKyuyuFileImportButton from '@/components/DdKyuyuFileImportButton'
import VTour from '@/components/DdCoachMark.vue'
import CoachMark from './CoachMark/D2FUET0011.js'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditDialog = () => import('@/components/DdEditDialog')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTimeBox = () => import('@/components/DdTimeBox')

export default {
  name: 'NenryoListEdit',
  mixins: [flowMixin],
  components: {
    VTour,
    DdCustomButton,
    DdTransparentButton,
    DdDateRangeBox,
    DdFileInput,
    DdSpreadSheet,
    DdKyuyuFileImportButton,
    DdCodeTextBox,
    DdDataTable,
    DdDefaultButton,
    DdDropDown,
    DdEditDialog,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRadioButton,
    DdRowCountBox,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdTextBox,
    DdTimeBox
  },
  data: () => ({
    // 一覧制御用
    itemsPerPage: 100,
    page: 1,
    isTorikomiHide: false,
    isConditionHide: false,
    isTemplateDownloader: false,
    isExcelDownloader: false,

    headers: [],
    rows: [],
    conditions: {},
    selected: [],
    target: [],
    modeKengen: 0,
    pageCount: 0,
    // 操作ガイド用
    startCoachMark: false,
    steps: CoachMark.STEPS,
    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    // 画面表示制御
    torikomiConditonsRequired: true,
    tableRowRequired: true,
    headerMode: 1,
    isShowDetailColumn: true,

    // スプレッドシートオプション
    option: {
      // // テーブル最大高さ
      tableHeight: '70vh',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: false,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: false,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: false,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 25,
      paginationOptions: [10, 25, 50, 100],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む'
      }
    },
    // 画面側からのエラーリスト
    outsideErrorList: []
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem, index) => {
        elem.rowNo = index + 1
        elem.hasseiYmd = elem.hasseiYmd ? filter.dateFormatter(elem.hasseiYmd) : ''
        elem.hasseiHms = elem.hasseiHms ? (elem.hasseiHms).slice(0, 5) : ''
        elem.sharyoShozokuEigyoshoDisp = elem.sharyoShozokuEigyoshoCd ? elem.sharyoShozokuEigyoshoCd + ' : ' + elem.sharyoShozokuEigyoshoNm : ''
        elem.hasseiYmdDisp = elem.hasseiYmd ? filter.dateFormatter(elem.hasseiYmd) : ''
        elem.hasseiHmsDisp = elem.hasseiHms ? (elem.hasseiHms).slice(0, 5) : ''
        elem.torikomiShiiresakiDisp = elem.torihikisakiCd ? elem.torihikisakiCd + ' : ' + elem.torihikisakiNm : elem.torikomiShiiresakiCd
        elem.torikomiSharyoDisp = elem.sharyoNo ? elem.sharyoNo + ' : ' + elem.mstSharyoNm : elem.torikomiSharyoNo
        elem.suryoDisp = elem.suryo ? filter.numericFormatter(elem.suryo) : ''
        elem.keihiTankaDisp = elem.keihiTanka ? filter.numericFormatter(elem.keihiTanka) : ''
        elem.odoMaterDisp = elem.odoMater ? filter.numericFormatter(elem.odoMater) : ''
        elem.sagyoJisshiBashoDisp = elem.sagyoJisshiBasho ? elem.sagyoJisshiBasho : ''
        elem.kessaiCardNumberDisp = elem.kessaiCardNumber ? elem.kessaiCardNumber : ''
        return elem
      })
    },
    dispHeader () {
      const self = this
      let header = []
      if (self.headerMode === 1) {
        header = [
          { text: 'ID', value: 'id', align: ' d-none' },
          { text: '編集', value: 'editAction', align: 'center', sortable: false, width: '80px' },
          { text: '反映', value: 'actions', align: 'center', sortable: false, width: '80px' },
          { text: '変更状況', value: 'memo', align: 'center', width: '80px' },
          { text: '発生年月日', value: 'hasseiYmd', width: '175px' },
          { text: '発生時刻', value: 'hasseiHms', width: '125px' },
          { text: '車両番号/自動車表示名', value: 'mstSharyoId', width: '270px' },
          { text: '燃料区分', value: 'nenryoShuruiKbn', width: '155px' },
          { text: '数量', value: 'suryo', align: 'end' },
          { text: '単価', value: 'keihiTanka', align: 'end' },
          { text: '金額', value: 'keihiKingaku', align: 'end' },
          { text: '給油時オド', value: 'odoMater' },
          { text: '仕入先', value: 'torihikisakiId', width: '270px' },
          { text: '営業所', value: 'sharyoShozokuEigyoshoDisp', width: '270px' },
          { text: '車種', value: 'shashuSbtNm', width: '85px' },
          { text: '給油SS', value: 'sagyoJisshiBasho', width: '300px' },
          { text: 'カードNo', value: 'kessaiCardNumber', width: '200px' },
          { text: '車両経費No', value: 'sharyoKeihiNo' }
        ]
      } else {
        header = [
          { text: 'ID', value: 'id', align: ' d-none' },
          { text: '行', value: 'rowNo', align: 'center', sortable: false, width: '80px' },
          { text: '発生年月日', value: 'hasseiYmdDisp', width: '175px' },
          { text: '発生時刻', value: 'hasseiHmsDisp', width: '125px' },
          { text: '仕入先', value: 'torikomiShiiresakiDisp', width: '270px' },
          { text: '営業所', value: 'sharyoShozokuEigyoshoDisp', width: '270px' },
          { text: '車種', value: 'shashuSbtNm', width: '85px' },
          { text: '車両番号/自動車表示名', value: 'torikomiSharyoDisp', width: '270px' },
          { text: '燃料区分', value: 'nenryoShuruiKbnNm', width: '155px' },
          { text: 'エラーメッセージ', value: 'errMessage' },
          { text: '数量', value: 'suryoDisp', align: 'end' },
          { text: '単価', value: 'keihiTankaDisp', align: 'end' },
          { text: '金額', value: 'keihiKingaku', align: 'end' },
          { text: '給油時オド', value: 'odoMaterDisp', align: 'end' },
          { text: '給油SS', value: 'sagyoJisshiBashoDisp', width: '300px' },
          { text: 'カードNo', value: 'kessaiCardNumberDisp', width: '200px' },
          { text: '車両経費No', value: 'sharyoKeihiNo' }
        ]
      }
      return header
    },
    computedColNumList () {
      var result = {}
      this.headers.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    },
    // 営業所フィルター
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    // 取引先フィルター
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // 仕入先フィルター
    filteredShiiresakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.shiiresakiFlg === true
      })
    },
    // 車両マスタフィルター
    filteredMstSharyoList () {
      const target = filter.dateFormatter(new Date())
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 給油実績データ取込レイアウト区分フィルター
    filteredNenryoTorikomiLayoutKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF108')
    },
    // 車種フィルター
    filteredShashuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 燃料区分フィルター
    filteredFuelKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF053')
    },
    // Templateボタン活性条件
    isTemplateButtonDisabled () {
      return this.isTemplateDownloader
    },
    // Excelボタン活性条件
    isExcelButtonDisabled () {
      return this.rows.length === 0 || this.isExcelDownloader
    },
    // 保存ボタン活性条件
    isMultiSaveButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.memo !== 'Ｅ'
      })
      if (saveTargetRow.length < 1) {
        return true
      }
      return false
    },
    // 削除ボタン活性条件
    isMultiDeleteButtonDisabled () {
      if (this.modeKengen !== 2) {
        return false
      }
      const deleteTagetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.delFlg === true
      })
      if (deleteTagetRow.length > 0) {
        return false
      }
      return true
    },
    multiDeleteButtonDisp () {
      if (this.modeKengen !== 2 || this.headerMode === 2) {
        return false
      }
      return true
    },
    newAddButtonDisp () {
      if (this.modeKengen === 0 || this.headerMode === 2) {
        return false
      }
      return true
    },
    isEditReadonly () {
      if (this.modeKengen === 0 || this.headerMode === 2) {
        return true
      }
      return false
    },
    isReadOnly () {
      if (this.modeKengen === 0) {
        return true
      }
      return false
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'msttorihikisaki', 'vwcmsteigyoshojininlist', 'vwcmstsharyo', 'msyskubun', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('PrmHaishaList.defineHeaderPromise')
            self.setHeader()
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('PrmHaishaList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('PrmHaishaList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('PrmHaishaList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('PrmHaishaList.restoreViewPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
              self.searchText = c.cache.value.searchText || ''
              self.rows = c.cache.value.rows || []
            }
            resolve()
          })
        },
        settingViewScroll: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          console.log('PrmHaishaList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.torikomiConditonsRequired = false
      this.tableRowRequired = false
      this.$nextTick(function () {
        this.searchAction()
      })
    },
    searchAction: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCD2fued0010/search', self.conditions)
              .then((data) => {
                self.setHeader()
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.headerMode = 1
          self.torikomiConditonsRequired = true
          self.tableRowRequired = true
          const res = data.payload
          res.map((elem, index) => {
            // スプレッドシート用にここで編集
            elem.rowNo = index + 1
            // ドロップダウン用編集
            // elem.mstJininNm = [undefined, null].includes(elem.mstJininNm) ? '未選択' : elem.mstJininNm
            elem.mstSharyoNm = [undefined, null].includes(elem.mstSharyoNm) ? '未選択' : elem.mstSharyoNm
            elem.nenryoShuruiKbnNm = [undefined, null].includes(elem.nenryoShuruiKbnNm) ? '未選択' : elem.nenryoShuruiKbnNm
            elem.torihikisakiNm = [undefined, null].includes(elem.torihikisakiNm) ? '未選択' : elem.torihikisakiNm
            elem.hasseiYmdDisp = elem.hasseiYmd ? filter.dateFormatter(elem.hasseiYmd) : ''
            elem.hasseiHmsDisp = elem.hasseiHms ? (elem.hasseiHms).slice(0, 5) : ''
            elem.torikomiShiiresakiDisp = elem.torihikisakiCd ? elem.torihikisakiCd + ' : ' + elem.torihikisakiNm : elem.torikomiShiiresakiCd
            elem.torikomiSharyoDisp = elem.sharyoNo ? elem.sharyoNo + ' : ' + elem.mstSharyoNm : elem.torikomiSharyoNo
            elem.suryoDisp = elem.suryo ? filter.numericFormatter(elem.suryo) : ''
            elem.keihiTankaDisp = elem.keihiTanka ? filter.numericFormatter(elem.keihiTanka) : ''
            elem.odoMaterDisp = elem.odoMater ? filter.numericFormatter(elem.odoMater) : ''
            elem.sagyoJisshiBashoDisp = elem.sagyoJisshiBasho ? elem.sagyoJisshiBasho : ''
            elem.kessaiCardNumberDisp = elem.kessaiCardNumber ? elem.kessaiCardNumber : ''
            elem.editFlg = false
            elem.editMode = false
            return elem
          })
          self.rows = res
          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              self.cloneRows = dolly.clone(self.getCloneTargetMethod())
            })
          self.$nextTick(function () {
            if (!self.isShowDetailColumn) self.hideDetailColumns()
          })
        },
        getSavedInputMethod: function () {
          return {}
        },
        failureValidateMethod: function () {
          self.torikomiConditonsRequired = true
          self.tableRowRequired = true
        }
      }
      this.search(opt)
    },
    // 検索前チェック
    searchValidate: function () {
      // 発生年月日不整合チェック
      if (this.conditions.hasseiYmdStartString && this.conditions.hasseiYmdEndString) {
        const msg1 = validators.compareDate(this.conditions.hasseiYmdStartString, this.conditions.hasseiYmdEndString)
        if (msg1 !== undefined) {
          this.$refs.hasseiYmdStartString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.hasseiYmdEndString[this.Ctrls.SET_INVALID_METHOD](msg1)
          modals.showToastMessage('COME0014', null, 500, null, 'error')
          this.torikomiConditonsRequired = true
          this.tableRowRequired = true
          return false
        }
      }
      return true
    },
    onClearButtonClick: function (e) {
      if (this.headerMode === 1) {
        this.onSearchConditonsClearButtonClick()
      } else {
        this.onFileInputClearButtonClick()
      }
    },
    onFileInputClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear(1)
    },
    onSearchConditonsClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear(2)
    },
    // p = 1:ファイル取込の設定条件をクリアする
    // p = 2:検索条件をクリアする
    // p = 未指定:すべてクリア
    clear: function (p) {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.initBindVariables(p)
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onFileImportButtonClick: function (e) {
      let errorCount = 0
      if ((['', null, undefined]).includes(this.conditions.importShiiresakiId)) {
        this.$refs.importShiiresakiId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        errorCount++
      }
      if ((['', null, undefined]).includes(this.conditions.importFileKbn)) {
        this.$refs.importFileKbn[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        errorCount++
      }
      if ((['', null, undefined]).includes(this.conditions.uploadFileData)) {
        this.$refs.file[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        errorCount++
      }
      if (errorCount > 0) { return }
      const importConditions = {
        importShiiresakiId: this.conditions.importShiiresakiId,
        importFileKbn: this.conditions.importFileKbn,
        uploadFileName: this.conditions.uploadFileName,
        uploadFileData: this.conditions.uploadFileData
      }
      this.Effects.loadStart()
      this.HttpClient.post('/api/v1/vwCD2fued0010/NenryoFileImport', importConditions)
        .then((data) => {
          if (data.isValid) {
            console.log('retdata', data)
            this.headerMode = 2
            modals.showToastMessage(data.summaryMessage.messageCd, null, 500, null, 'info')
            this.rows = data.payload.resultList
            this.recordCount = data.payload.recordCount
            this.successCount = data.payload.successCount
            this.errorCount = data.payload.errorCount
            this.Effects.loadComplete()
            // this.transition(0, { id: data.payload, edit: 1 })
          } else {
            modals.showToastMessage(data.summaryMessage.messageCd, null, 500, null, 'error')
            this.Effects.loadComplete()
          }
        }).catch((e) => {
          console.log('error', e)
          modals.showToast(e.message, null, 500, null, 'error')
          this.Effects.loadComplete()
        })
    },
    onTorikomiTemplateButtonClick: function (e) {
      this.isTemplateDownloader = true
      this.HttpClient
        .requestFileByPost('/api/v1/VwCD2fued0010/NenryoTorikomiTemplateOutput', this.conditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('templateDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '給油実績取込テンプレート_' + ts + '.xlsx'
          elem.click()
          modals.showToastMessage('COMI0005', null, 500, null, 'info')
          this.isTemplateDownloader = false
        })
    },
    onExcelButtonClick: function (e) {
      this.isExcelDownloader = true
      this.HttpClient
        .requestFileByPost('/api/v1/VwCD2fued0010/excelOutput', this.conditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('exceldownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '給油実績一覧_' + ts + '.xlsx'
          elem.click()
          modals.showToastMessage('COMI0005', null, 500, null, 'info')
          this.isExcelDownloader = false
        })
    },
    storeFileInfo: function (p) {
      console.log('file selected', p)
      if (p === undefined || p === null) {
        this.conditions.uploadFileName = ''
        this.conditions.uploadFileData = ''
        return
      }
      this.clearInvalidMessage(this.$refs)
      this.Effects.loadStart()
      this.conditions.uploadFileName = p.name

      const fr = new FileReader()
      fr.readAsDataURL(p)
      fr.addEventListener('load', () => {
        this.conditions.uploadFileData = fr.result
      })
      this.Effects.loadComplete()
      console.log('file selected e')
    },
    onCancel: function (item) {
      // サマリメッセージ初期化
      this.clearSummaryMessage()

      const index = this.rows.indexOf(item)
      this.getData(item.id, index)
    },

    /**
     * 一覧ヘッダ作成
     */
    setHeader: function () {
      const self = this
      return new Promise(resolve => {
        const target = filter.dateFormatter(new Date())
        // 燃料区分
        const wkNenryoKbnList = self.kubunListFilterForSpreadSheetDropDownItem(self.kubunList, 'SFF053')

        // 人員
        /* 経費使用者は何で入れたのか不明
        const mJininList = this.jininList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter(function (elem) {
          return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
        })
        var wkJininList = ['未選択']
        const tJininList = mJininList.map(elem => {
          return elem.jininNmSei
        })
        wkJininList = wkJininList.concat(tJininList)
        */

        // 車両
        const mSharyoList = self.sharyoList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter(function (elem) {
          return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
        })
        var wkSharyoList = ['未選択']
        const tSharyoList = mSharyoList.map(elem => {
          return elem.jidoshaHyojiNm
        })
        wkSharyoList = wkSharyoList.concat(tSharyoList)

        // 仕入先
        const mShiiresakiList = self.filteredMstTorihikisaki.filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.shiiresakiFlg === true
        })
        var wkShiiresakiList = ['未選択']
        const tShiiresakiList = mShiiresakiList.map(elem => {
          return elem.torihikisakiNm
        })
        wkShiiresakiList = wkShiiresakiList.concat(tShiiresakiList)
        // ヘッダー定義
        self.headers = [
          { title: '', name: 'id', type: 'hidden' },
          { title: '', name: 'rowNo', type: 'hidden' },
          { title: '区分', name: 'memo', type: 'text', customInput: null, readOnly: true, width: '40px' },
          { title: '変更', name: 'editFlg', type: 'checkbox', customInput: null, width: '35px' },
          { title: '', name: 'errFlg', type: 'hidden' },
          { title: '削除', name: 'delFlg', type: 'checkbox', customInput: null, width: '35px' },
          { title: '発生年月日', name: 'hasseiYmd', type: null, customInput: 'date', validateType: 'Date', required: true, readOnly: false, width: '130px' },
          { title: '発生時刻', name: 'hasseiHms', type: null, customInput: 'time', validateType: 'Time', readOnly: false, width: '100px' },
          { title: '自動車表示名', name: 'mstSharyoNm', type: 'dropdown', customInput: null, source: wkSharyoList, width: '170px', autocomplete: true },
          { title: '燃料区分', name: 'nenryoShuruiKbnNm', type: 'dropdown', customInput: null, source: wkNenryoKbnList, width: '130px', autocomplete: true },
          { title: '給油量(ℓ)', name: 'suryo', type: null, customInput: 'numeric', customInputIntDigit: 11, customInputDecimalDigit: 2, validateType: 'Numerical', readOnly: false, width: '100px', customInputSuffix: 'ℓ' },
          { title: '給油時オド(Km)', name: 'odoMater', type: null, customInput: 'numeric', customInputIntDigit: 11, customInputDecimalDigit: 3, validateType: 'Numerical', readOnly: false, width: '120px', customInputSuffix: 'Km' },
          { title: '単価(円)', name: 'keihiTanka', type: null, customInput: 'numeric', customInputIntDigit: 11, customInputDecimalDigit: 2, validateType: 'Numerical', readOnly: false, width: '100px', customInputSuffix: '円' },
          { title: '金額(円)', name: 'keihiKingaku', type: null, customInput: 'numeric', customInputIntDigit: 11, customInputDecimalDigit: 0, validateType: 'Numerical', readOnly: false, width: '100px', customInputSuffix: '円' },
          { title: '仕入先', name: 'torihikisakiNm', type: 'dropdown', customInput: null, source: wkShiiresakiList, width: '190px', autocomplete: false },
          { title: '給油SS', name: 'sagyoJisshiBasho', type: null, customInput: 'text', customInputLength: 100, validateType: 'Free', readOnly: false, width: '180px' },
          { title: 'カードNo', name: 'kessaiCardNumber', type: null, customInput: 'text', customInputLength: 50, validateType: 'Free', readOnly: false, width: '140px' },
          { title: '車両経費No', name: 'sharyoKeihiNo', type: 'text', customInput: null, readOnly: true, width: '100px' }
        ]

        resolve()
      })
    },

    /**
     * 更新後の再取得 ※対象行のデータとClone情報を差し替える
     * @param {} recId
     * @param {*} rowIndex
     * @returns
     */
    getData: function (recId, rowIndex) {
      // サマリメッセージ初期化
      // this.clearSummaryMessage()
      if (recId > 0) {
        return new Promise((resolve) => {
          this.HttpClient
            .get(`/api/v1/VwCD2fued0010/find?id=${recId}`)
            .then((data) => {
              const rec = data.payload
              // 取得データを差し替え
              rec.editFlg = false
              rec.editMode = false
              // rec.mstJininNm = [undefined, null].includes(rec.mstJininNm) ? '未選択' : rec.mstJininNm
              rec.mstSharyoNm = [undefined, null].includes(rec.mstSharyoNm) ? '未選択' : rec.mstSharyoNm
              rec.nenryoShuruiKbnNm = [undefined, null].includes(rec.nenryoShuruiKbnNm) ? '未選択' : rec.nenryoShuruiKbnNm
              rec.torihikisakiNm = [undefined, null].includes(rec.torihikisakiNm) ? '未選択' : rec.torihikisakiNm
              rec.memo = ''
              rec.hasseiYmd = rec.hasseiYmd ? filter.dateFormatter(rec.hasseiYmd) : ''
              rec.hasseiHms = rec.hasseiHms ? (rec.hasseiHms).slice(0, 5) : ''
              Object.assign(this.rows[rowIndex], rec)
              // CloneData更新
              this.cloneRows = dolly.clone(this.getCloneTargetMethod())
              // 画面への再描写 ※強制発火用にspliceを実行
              this.rows.splice()
              resolve()
            })
        })
      } else {
        const newrow = {
          id: 0,
          editFlg: false,
          editMode: true,
          rowNo: this.rows.length + 1,
          // mstJininNm: '未選択',
          mstSharyoNm: '未選択',
          nenryoShuruiKbnNm: '軽油',
          torihikisakiNm: '未選択',
          memo: '',
          hasseiYmd: '',
          hasseiHms: '',
          torihikisakiId: '',
          mstSharyoId: '',
          nenryoShuruiKbn: '',
          suryo: '',
          keihiTanka: '',
          keihiKingaku: '',
          odoMater: ''
        }
        Object.assign(this.rows[rowIndex], newrow)
        // CloneData更新
        this.cloneRows = dolly.clone(this.getCloneTargetMethod())
        // 画面への再描写 ※強制発火用にspliceを実行
        this.rows.splice()
      }
    },
    onSave: function (item) {
      const saveTargetRow = Object.assign({}, item)
      if ((['', null, undefined]).includes(saveTargetRow.hasseiYmd)) {
        modals.showToastMessage('COME0001', null, 500, null, 'error')
        return
      }
      saveTargetRow.suryo = saveTargetRow.suryo ? this.getNullValue(saveTargetRow.suryo) : null
      saveTargetRow.keihiTanka = saveTargetRow.keihiTanka ? this.getNullValue(saveTargetRow.keihiTanka) : null
      saveTargetRow.keihiKingaku = saveTargetRow.keihiKingaku ? this.getNullValue(saveTargetRow.keihiKingaku) : null
      saveTargetRow.odoMater = saveTargetRow.odoMater ? this.getNullValue(saveTargetRow.odoMater) : null

      this.target = [saveTargetRow]
      this.torikomiConditonsRequired = false
      this.tableRowRequired = false
      this.$nextTick(function () {
        this.saveAction(saveTargetRow)
      })
    },
    onMultiSaveButtonClick: function (e) {
      const self = this
      // 変更フラグONかつ発生年月日≠Nullのもののみ対象
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.delFlg === false && !['', null, undefined].includes(elem.hasseiYmd)
      })
      if (saveTargetRow.length < 1) { return }

      saveTargetRow.map((elem) => {
        elem.id = [undefined, null, ''].includes(elem.id) ? 0 : elem.id
        // 数値変換
        elem.suryo = elem.suryo ? self.getNullValue(elem.suryo) : null
        elem.keihiTanka = elem.keihiTanka ? self.getNullValue(elem.keihiTanka) : null
        elem.keihiKingaku = elem.keihiKingaku ? self.getNullValue(elem.keihiKingaku) : null
        elem.odoMater = elem.odoMater ? self.getNullValue(elem.odoMater) : null
        return elem
      })

      // 入力チェック
      /*
      if (!self.spreadSheetRegisterValidate(saveTargetRow)) {
        modals.showToast('入力値に誤りがあります。', null, 500, null, 'error')
        return
      }
      */

      /**
       * リスト項目テキスト⇒ID/Code変換
       */
      // 車両ID変換
      saveTargetRow.filter((elem) => {
        return ![null, ''].includes(elem.mstSharyoNm)
      }).map((elem) => {
        const m = self.filteredMstSharyoList.filter(function (item) {
          return item.jidoshaHyojiNm === elem.mstSharyoNm
        })
        if (m.length > 0) {
          elem.mstSharyoId = m[0].id
        }
        return elem
      })
      // 仕入先ID変換
      saveTargetRow.filter((elem) => {
        return ![null, ''].includes(elem.torihikisakiNm)
      }).map((elem) => {
        const m = self.filteredShiiresakiList.filter(function (item) {
          return item.torihikisakiNm === elem.torihikisakiNm
        })
        if (m.length > 0) {
          elem.torihikisakiId = m[0].id
        }
        return elem
      })
      // 燃料区分変換
      saveTargetRow.filter((elem) => {
        return ![null, ''].includes(elem.nenryoShuruiKbnNm)
      }).map((elem) => {
        const m = self.kubunList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.kbnShuruiCd === 'SFF053' && item.codeNm === elem.nenryoShuruiKbnNm
        })
        if (m.length > 0) {
          elem.nenryoShuruiKbn = m[0].code
        }
        return elem
      })

      this.torikomiConditonsRequired = false
      this.tableRowRequired = false
      this.target = saveTargetRow
      this.$nextTick(function () {
        self.saveAction(saveTargetRow)
      })
    },
    saveAction: function (p) {
      // this.Effects.loadStart()
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.HttpClient.post('/api/v1/VwCD2fued0010/RegisterMulti', self.target)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.selected = []
            self.torikomiConditonsRequired = true
            self.tableRowRequired = true
            const dataList = data.payload.item1
            dataList.map((elem) => {
              elem.editFlg = false
              elem.editMode = false
              // elem.mstJininNm = [undefined, null].includes(elem.mstJininNm) ? '未選択' : elem.mstJininNm
              elem.mstSharyoNm = [undefined, null].includes(elem.mstSharyoNm) ? '未選択' : elem.mstSharyoNm
              elem.nenryoShuruiKbnNm = [undefined, null].includes(elem.nenryoShuruiKbnNm) ? '未選択' : elem.nenryoShuruiKbnNm
              elem.torihikisakiNm = [undefined, null].includes(elem.torihikisakiNm) ? '未選択' : elem.torihikisakiNm
              elem.memo = ''
              elem.hasseiYmd = elem.hasseiYmd ? filter.dateFormatter(elem.hasseiYmd) : ''
              elem.hasseiHms = elem.hasseiHms ? (elem.hasseiHms).slice(0, 5) : ''
              return elem
            })
            const newDataRowList = self.target.filter(function (elem) {
              return elem.id < 1
            })
            newDataRowList.forEach(elem => {
              const index = this.rows.indexOf(elem)
              self.rows.splice(index, 1)
            })

            dataList.forEach(elem => {
              const tagetRow = self.rows.find(n => n.id === elem.id)
              if (tagetRow) {
                const index = this.rows.indexOf(tagetRow)
                // 取得データを差し替え
                Object.assign(this.rows[index], elem)
              } else {
                if (self.rows.length > 0) {
                  self.rows.push(elem)
                } else {
                  self.rows = [elem]
                }
              }
            })
            // CloneData更新
            self.cloneRows = dolly.clone(this.getCloneTargetMethod())
            // 画面への再描写 ※強制発火用にspliceを実行
            self.rows.splice()
            self.Effects.loadComplete()
            this.$nextTick(function () {
              if (!self.isShowDetailColumn) self.hideDetailColumns()
            })
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    // 登録前チェック
    registerValidate: function () {
      return true
    },
    // レコードチェック
    /*
    spreadSheetRegisterValidate: function (rows) {
      console.log('spreadSheetRegisterValidate', rows)
      let errorCnt = 0
      rows.forEach((rec) => {
        // 発生年月日
        const hasseiYmd = spsvalidator.dateValidate(rec.hasseiYmd)
        if (hasseiYmd !== null) {
          rec.hasseiYmd = hasseiYmd
        } else {
          errorCnt++
        }
        // 発生時刻
        if (![undefined, null, ''].includes(rec.hasseiHms)) {
          const hasseiHms = spsvalidator.timeValidate(rec.hasseiHms)
          if (hasseiHms !== null) {
            rec.hasseiHms = hasseiHms
          } else {
            errorCnt++
          }
        }
        // 給油量
        if (![undefined, null, ''].includes(rec.suryo) && spsvalidator.fixedNumericalDigitValidate(rec.suryo, 11, 3) === null) {
          errorCnt++
        }
        // 単価
        if (![undefined, null, ''].includes(rec.keihiTanka) && spsvalidator.fixedNumericalDigitValidate(rec.keihiTanka, 11, 3) === null) {
          errorCnt++
        }
        // 金額
        if (![undefined, null, ''].includes(rec.keihiKingaku) && spsvalidator.fixedNumericalDigitValidate(rec.keihiKingaku, 11, 3) === null) {
          errorCnt++
        }
        // 給油時オド
        if (![undefined, null, ''].includes(rec.odoMater) && spsvalidator.fixedNumericalDigitValidate(rec.odoMater, 11, 3) === null) {
          errorCnt++
        }
        // 給油SS
        if (![undefined, null, ''].includes(rec.sagyoJisshiBasho) && rec.sagyoJisshiBasho.length > 100) {
          errorCnt++
        }
        // カードNo
        if (![undefined, null, ''].includes(rec.kessaiCardNumber) && rec.kessaiCardNumber.length > 50) {
          errorCnt++
        }
      })

      return errorCnt === 0
    },
    */
    /**
     * 削除ボタン押下
     * @param {}
     */
    onMultiDeleteButtonClick: function (e) {
      const self = this
      // 未登録データの削除
      const deleteTagetRowZero = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.delFlg === true && elem.id === 0
      })
      deleteTagetRowZero.forEach(elem => {
        const index = self.rows.indexOf(elem)
        // 選択行を削除
        self.rows.splice(index, 1)
      })

      // 登録済みデータの削除
      const deleteTagetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.delFlg === true && elem.id > 0
      })
      if (deleteTagetRow.length < 1) { return }

      deleteTagetRow.map((elem) => {
        elem.suryo = elem.suryo ? self.getNullValue(elem.suryo) : null
        elem.keihiTanka = elem.keihiTanka ? self.getNullValue(elem.keihiTanka) : null
        elem.keihiKingaku = elem.keihiKingaku ? self.getNullValue(elem.keihiKingaku) : null
        elem.odoMater = elem.odoMater ? self.getNullValue(elem.odoMater) : null
        return elem
      })

      this.target = deleteTagetRow
      this.torikomiConditonsRequired = false
      this.tableRowRequired = false
      this.$nextTick(function () {
        self.deleteAction(deleteTagetRow)
      })
    },
    deleteAction: function (deleteTagetRow) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2fued0010/DeleteMulti', self.target).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        getSavedInputMethod: function () {
          return {}
        },
        settingReloadWindow: function () {
          return true
        },
        isInvokeCallbackOnSuccess: function () {
          return true
        },
        onSuccessCallback: function () {
          return new Promise(resolve => {
            const deleteTagetRow = self.rows.filter(function (elem) {
              // idなしで削除が立っているものも対象とする
              return elem.editFlg === true && elem.delFlg === true
            })
            deleteTagetRow.forEach(elem => {
              const index = self.rows.indexOf(elem)
              // 選択行を削除
              self.rows.splice(index, 1)
            })
            // CloneData更新
            self.cloneRows = dolly.clone(self.getCloneTargetMethod())
            // 画面への再描写 ※強制発火用にspliceを実行
            self.rows.splice()
            self.selected = []
            self.torikomiConditonsRequired = true
            self.tableRowRequired = true
            resolve()
          })
        },
        failureResponsePromise: () => {
          return new Promise(resolve => {
            self.torikomiConditonsRequired = true
            self.tableRowRequired = true
            resolve()
          })
        },
        onCancelClickMethod: function () {
          return new Promise(resolve => {
            self.torikomiConditonsRequired = true
            self.tableRowRequired = true
            resolve()
          })
        }
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },
    onNewRowButtonClick: function (e) {
      this.rowAppend(1)
    },
    rowAppend: function (num) {
      const self = this
      for (let i = 0; i < num; i++) {
        const newrow = {
          id: 0,
          editFlg: false,
          delFlg: false,
          editMode: false,
          rowNo: this.rows.length + 1,
          // mstJininNm: '未選択',
          mstSharyoNm: '未選択',
          nenryoShuruiKbnNm: '軽油',
          torihikisakiNm: '未選択',
          memo: '',
          hasseiYmd: '',
          hasseiHms: '',
          torihikisakiId: '',
          mstSharyoId: '',
          nenryoShuruiKbn: '',
          suryo: '',
          keihiTanka: '',
          keihiKingaku: '',
          odoMater: '',
          sharyoKeihiNo: ''
        }
        this.rows.push(newrow)
      }
      // CloneData更新
      this.cloneRows = dolly.clone(this.getCloneTargetMethod())
      // 画面への再描写 ※強制発火用にspliceを実行
      this.rows.splice()
      this.$nextTick(function () {
        if (!self.isShowDetailColumn) self.hideDetailColumns()
      })
    },
    // 項目表示切り替え
    showDetailColumns: function () {
      if (this.$refs.ddSpreadSheet === undefined) return
      // this.$refs.ddSpreadSheet.showColumn(this.computedColNumList.keihiTanka)
      // this.$refs.ddSpreadSheet.showColumn(this.computedColNumList.keihiKingaku)
      this.$refs.ddSpreadSheet.showColumn(this.computedColNumList.torihikisakiNm)
      this.$refs.ddSpreadSheet.showColumn(this.computedColNumList.sagyoJisshiBasho)
      this.$refs.ddSpreadSheet.showColumn(this.computedColNumList.kessaiCardNumber)
      this.$refs.ddSpreadSheet.showColumn(this.computedColNumList.sharyoKeihiNo)
      this.isShowDetailColumn = true
    },
    hideDetailColumns: function () {
      if (this.$refs.ddSpreadSheet === undefined) return
      // this.$refs.ddSpreadSheet.hideColumn(this.computedColNumList.keihiTanka)
      // this.$refs.ddSpreadSheet.hideColumn(this.computedColNumList.keihiKingaku)
      this.$refs.ddSpreadSheet.hideColumn(this.computedColNumList.torihikisakiNm)
      this.$refs.ddSpreadSheet.hideColumn(this.computedColNumList.sagyoJisshiBasho)
      this.$refs.ddSpreadSheet.hideColumn(this.computedColNumList.kessaiCardNumber)
      this.$refs.ddSpreadSheet.hideColumn(this.computedColNumList.sharyoKeihiNo)
      this.isShowDetailColumn = false
    },
    // Nullをゼロに変換(カンマ除去も)
    getNullValue (inputValue) {
      if (inputValue === null) { return '0' }
      if (inputValue === undefined) { return '0' }
      if (inputValue === '') { return '0' }
      return this.removeComma(inputValue)
    },
    removeComma: function (num) {
      if (!num) { return '0' }

      if (window.isFinite(num) === true) {
        return num.toString()
      }
      var removedNum = num.replace(/,/g, '')
      return removedNum
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    // p = 1:ファイル取込の設定条件をクリアする
    // p = 2:検索条件をクリアする
    // p = 未指定:すべてクリア
    initBindVariables: function (p) {
      const self = this
      const d = new Date()
      let initConditions = Object.assign({}, self.conditions)
      initConditions = {
        importShiiresakiId: p === 2 ? self.conditions.importShiiresakiId : null,
        importFileKbn: p === 2 ? self.conditions.importFileKbn : '01',
        uploadFileName: p === 2 ? self.conditions.uploadFileName : '',
        uploadFileData: p === 2 ? self.conditions.uploadFileData : '',
        hasseiYmdStartString: p === 1 ? self.conditions.hasseiYmdStartString : date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        hasseiYmdEndString: p === 1 ? self.conditions.hasseiYmdEndString : date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        torihikisakiId: p === 1 ? self.conditions.torihikisakiId : null,
        // sharyoShozokuEigyoshoId: p === 1 ? self.conditions.sharyoShozokuEigyoshoId : self.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(self.currentKaishaCode, self.eigyoshoList, 'eigyoshoCd', self.usersEigyoshoCd, filter.dateFormatter(d)).id : null,
        sharyoShozokuEigyoshoId: p === 1 ? self.conditions.sharyoShozokuEigyoshoId : null,
        shashuSbt: p === 1 ? self.conditions.shashuSbt : null,
        mstSharyoId: p === 1 ? self.conditions.mstSharyoId : null,
        nenryoShuruiKbn: p === 1 ? self.conditions.nenryoShuruiKbn : null
      }
      self.conditions = Object.assign({}, initConditions)
      self.searchText = ''
      self.selected = []

      self.rows = []
      self.target = []
      self.torikomiConditonsRequired = true
      self.tableRowRequired = true
      self.headerMode = 1
    },
    // 色かえる
    itemRowBackground (item) {
      return item.errMessage ? 'cellBackgroundColorRed' : 'cellBackgroundColorWhite'
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    // ダミー
    onDummyFunction: function () {
      return null
    }
  }
}
